import { render, staticRenderFns } from "./AudioPlayerQueue.vue?vue&type=template&id=1a635762"
import script from "./AudioPlayerQueue.vue?vue&type=script&lang=js"
export * from "./AudioPlayerQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports